<template>
    <div>
        <b-row>
            <b-col md="4" cols="12">
                <info-card
                label="نوع التبرع"
                :value="data.type === 'real_estates' ? 'تبرع بعقار' : 'تبرع بمركبة'"
                />
            </b-col>
        </b-row>
        <b-row v-if="data.type === 'real_estates'">
            <b-col md="4" cols="12">
                <info-card label="رقم العقار"
                :value="data.number"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="نوع العقار"
                :value="data.estate_type_id ? data.estate_type_id.name_ar : '' "
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="المنطقة الإدارية"
                :value="data.region"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="المحافظة"
                :value="data.governorate_id ? data.governorate_id.name_ar : '' "
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="الحصة السهمية"
                :value="data.equity_share"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="صيغة التملك"
                :value="data.possessive_form_id ? data.possessive_form_id.name_ar : '' "
                />
            </b-col>       
            <b-col md="4" cols="12">
                <info-card label="موضوع بالخدمة"
                :value="data.is_operating === 1 ? 'نعم' : 'لا'"
                />
            </b-col>       
            <b-col cols="4">
                <div class="info-card px-2 py-1 my-1">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                       وثيقة العقار
                    </div>
                    <div>
                    <b-button
                    
                        variant="flat-info"
                        v-b-toggle.doc-view
                        class="btn-icon mx-25"
                        v-b-tooltip.hover.v-info.bottom
                        title="عرض المستند المرفوع"
                        :to="{ name: 'file-view', query: { ep:data.estate_document } }"
                    >
                        <feather-icon icon="EyeIcon"
                    /></b-button>
                    </div>
                </div>
                <div>
                    <hr />
                </div>
                </div>
            </b-col> 
        </b-row>
        <b-row v-else>
            <b-col md="4" cols="12">
                <info-card label="نوع المركبة"
                :value="data.machine_type_id ? data.machine_type_id.name_ar : '' "
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card
                label="الطراز"
                :value="data.model"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="رقم اللوحة"
                :value="data.plate_number"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="محافظة التسجيل"
                :value="data.governorate_id ? data.governorate_id.name_ar : '' "
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="الرقم التسلسلي"
                :value="data.serial_number"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="رقم الهيكل"
                :value="data.structure_no"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="رقم المحرك"
                :value="data.engine_number"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="اللون"
                :value="data.color"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="سنة الصنع"
                :value="data.year"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="نوع الوقود"
                :value="data.fuel_type_id ? data.fuel_type_id.name_ar : ''"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="عدد الركاب"
                :value="data.passengers_number"
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="صيغة التملك"
                :value="data.possessive_form_id ? data.possessive_form_id.name_ar : '' "
                />
            </b-col>
            <b-col md="4" cols="12">
                <info-card label="معفاة من الضرائب"
                :value="data.tax === true ? 'نعم' : 'لا'"
                />
            </b-col>
            <b-col cols="4">
                <div class="info-card px-2 py-1 my-1">
                <div class="d-flex align-items-center justify-content-between">
                    <div>
                       وثيقة الملكية
                    </div>
                    <div>
                    <b-button
                    
                        variant="flat-info"
                        v-b-toggle.doc-view
                        class="btn-icon mx-25"
                        v-b-tooltip.hover.v-info.bottom
                        title="عرض المستند المرفوع"
                        :to="{ name: 'file-view', query: { ep:data.ownership_doc } }"
                    >
                        <feather-icon icon="EyeIcon"
                    /></b-button>
                    </div>
                </div>
                <div>
                    <hr />
                </div>
                </div>
            </b-col>        
        </b-row>
    </div>
  </template>
  
  <script>
  import { BCard , BImg , BCol , BRow , VBToggle , VBTooltip , BButton } from "bootstrap-vue";
  import InfoCard from "@/components/InfoCard.vue";
  export default {
    components: {
        BCard, BImg , BCol , InfoCard , BRow , BButton
    },
    props: {
        data : Object ,
    },
    
    directives: {
        "b-toggle": VBToggle,
        "b-tooltip": VBTooltip,
    },
  };
  </script>